/**
 * Import ZIP pacchetti crash (POST /Crash/import-zip) e storico (GET /Crash/package-exports).
 * Stessi ruoli: OrganizationAdmin (2) e MultiOrganizationAdmin (3).
 *
 * @param {number | undefined | null} userType
 * @returns {boolean}
 */
export function canImportCrashZipPackage(userType) {
  const type = Number(userType)
  return type === 2 || type === 3
}

/**
 * @param {number | undefined | null} userType
 * @returns {boolean}
 */
export function canViewPackageImportsList(userType) {
  return canImportCrashZipPackage(userType)
}
